<template>
  <div class="mc-download-button">
    <div class="__button" @click="$emit('click')">
      <div
        class="__logo"
        :style="{
          backgroundImage: 'url(' + require(`../assets/${icon}.png`) + ')'
        }"
      ></div>
      <div class="download-choose" v-show="showDownload">
        <div class="google-play" @click.stop="$emit('googlePlay')"></div>
        <div class="download" @click.stop="$emit('download')"></div>
      </div>
      <div class="text">{{ text }}</div>
      <div class="version" v-if="version">{{ `v${version}` }}</div>
      <div class="__download">
        <div class="download-img"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DownloadButton",

  components: {},

  props: {
    icon: String,
    text: String,
    version: String,
    showDownload: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
.mc-download-button {
  padding-bottom: 10px;
  text-align: center;
  width: 240px;
  margin: auto;
  .__button {
    position: relative;
    display: flex;
    align-items: center;
    margin: auto;
    padding: 8px 0;
    background-color: #fff;
    font-size: 15px;
    border-radius: 15px;
    box-shadow: 0 0 20px #e6e6e6;
    > .download-choose {
      position: absolute;
      top: -100px;
      left: 0;
      width: 100%;
      height: 94.28px;
      background: url(../assets/download_android.png)  center/contain no-repeat;
      > .google-play {
        height: 50%;
      }
      > .download {
        height: 50%;
      }
    }
    .__logo {
      width: 30px;
      height: 30px;
      background-size: cover;
      background-repeat: no-repeat;
      margin-left: 8px;
      margin-right: 8px;
    }
    .version {
      font-size: 12px;
      color: #999;
      padding-left: 10px;
    }
    .__download {
      flex: 1;
      height: 15px;
      display: flex;
      flex-direction: row-reverse;
      .download-img {
        margin-right: 15px;
        width: 14px;
        background: url(../assets/download.png) center/contain no-repeat;
      }
    }
  }
}
</style>
